import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import DailyLoss from "../../../assets/icons/DailyLoss.svg";
import initialBalance from "../../../assets/icons/initialBalance.svg";
import minimunTradingDay from "../../../assets/icons/mininumTradingDays.svg";
import profitTarget from "../../../assets/icons/profitTarget.svg";
import "./style.scss";
import { useSelector } from "react-redux";
import { formatUSD } from "../../../utils/helpers/string";

const Goals = ({ programObjective, data }) => {
  const { selectedBrand } = useSelector((state) => state.brand);

  const calculateRemainingTime = () => {
    const currentGMTTime = new Date();
    const targetGMT2Time = new Date();

    if (selectedBrand?.brand === "crypto_edge") {
      targetGMT2Time.setUTCHours(0, 0, 0, 0); // 12 AM UTC
    } else {
      targetGMT2Time.setUTCHours(22, 0, 0, 0); // 10 PM UTC
    }

    let remaining = targetGMT2Time - currentGMTTime;

    if (remaining <= 0) {
      const nextDayGMT2Time = new Date(targetGMT2Time);
      nextDayGMT2Time.setDate(nextDayGMT2Time.getDate() + 1);
      remaining = nextDayGMT2Time - currentGMTTime;
    }

    return remaining;
  };

  const [timeRemaining, setTimeRemaining] = useState(calculateRemainingTime());
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(timeRemaining - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeRemaining]);

  const showRemaining = () => {
    const hours = Math.floor((timeRemaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((timeRemaining % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000);

    const pad = (num) => String(num).padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const GoalsOverview = [
    {
      heading: "Max loss",
      minMax: programObjective?.max_loss ? formatUSD(programObjective?.max_loss || 0) : programObjective?.max_loss,
      status: programObjective?.max_loss_status,
      target: formatUSD(programObjective?.max_loss_target || 0),
      remaining: formatUSD(programObjective?.remaining_max_loss || 0),
      icon: minimunTradingDay,
      maxLimitPerc: `${(Math.abs(programObjective?.max_loss_target) / programObjective?.max_loss_threshold || 0) * 100}`,
      percentage: `${(Math.abs(programObjective?.max_loss) / programObjective?.max_loss_target || 0) * 100}`,
      threshold: formatUSD(programObjective?.max_loss_threshold || 0),
      isEnabled: true,
    },
    {
      heading: "Profit",
      minMax: programObjective?.profit ? formatUSD(programObjective?.profit || 0) : programObjective?.profit,
      status: programObjective?.profit_status,
      target: formatUSD(programObjective?.profit_target || 0),
      remaining: formatUSD(programObjective?.remaining_profit || 0),
      icon: profitTarget,
      percentage: `${(programObjective?.profit / programObjective?.profit_target || 0) * 100}`,
      isEnabled: true,
    },
    {
      heading: "Daily loss",
      minMax: programObjective?.profit ? formatUSD(programObjective?.max_daily_loss || 0) : programObjective?.profit,
      status: programObjective?.max_daily_loss_status,
      target: formatUSD(programObjective?.max_daily_loss_target || 0),
      remaining: formatUSD(programObjective?.remaining_daily_max_loss || 0),
      icon: DailyLoss,
      maxLimitPerc: `${(Math.abs(programObjective?.max_daily_loss_target) / programObjective?.max_daily_loss_threshold || 0) * 100}`,
      percentage: `${(Math.abs(programObjective?.max_daily_loss) / programObjective?.max_daily_loss_target || 0) * 100}`,
      threshold: formatUSD(programObjective?.max_daily_loss_threshold || 0),
      isEnabled: true,
    },
    {
      heading: "Trading days",
      minMax: programObjective?.trading_days,
      status: programObjective?.trading_days_status,
      target: programObjective?.trading_days_target,
      remaining: programObjective?.remaining_trading_days,
      icon: initialBalance,
      percentage: `${(programObjective?.trading_days / programObjective?.trading_days_target || 0) * 100}`,
      isEnabled: programObjective?.trading_days === null ? false : true,
    },
    {
      heading: "Profitable Trading Days",
      minMax: data?.profitable_trading_days,
      // status: programObjective?.profitable_trading_days_status || "In Progress",
      target: programObjective?.profitable_trading_days_target || 7,
      remaining: Math.max(0, (programObjective?.profitable_trading_days_target || 7) - (data?.profitable_trading_days || 0)),
      icon: initialBalance,
      percentage: `${Math.max(0, (data?.profitable_trading_days / (programObjective?.profitable_trading_days_target || 7) || 0) * 100)}`,
      isEnabled: false,
    },
  ];
  console.log(GoalsOverview, "GoalsOverviewGoalsOverview");

  let accountPassed = true;
  for (const goal of GoalsOverview) {
    if (goal.status !== "Passed") {
      accountPassed = false;
      break;
    }
  }

  const breachedReasonMap = {
    one_per_risk_limit: "1% Risk Limit",
    max_d: "Max Drawdown",
    max_dd: "Max Daily Drawdown",
    carry_over: "Carry Over / Weekend Holding",
    min_seven_profitable_days: "Minimum Profitable Days",
  };

  return (
    <div className="goals_overview_contaniner">
      <div className="goalsHeading">
        <h1>Goals Overview</h1>
      </div>
      {accountPassed && (
        <div className="goals_lines">
          <p>You have successfully passed this phase of your evaluation! You will receive an e-mail with confirmation that your new account has been set up to continue to the next phase.</p>
        </div>
      )}
      <div className="goalsContent">
        {GoalsOverview?.map((item, index) => {
          console.log("item", item, index);
          if (item?.isEnabled) {
            return (
              <div
                className={`goalBox ${item.heading === "Max loss"
                  ? "maxLoss"
                  : item.heading === "Profit"
                    ? "profit"
                    : item.heading === "Daily loss"
                      ? "dailyLoss"
                      : item.heading === "Trading days"
                        ? "tradingDays"
                        : "tradingDays"
                  }`}
                key={index}
              >
                <div className="goalBox_details">
                  <div className="goalboxDetailHeader">
                    <h1>{item.heading}</h1>
                  </div>
                  <div className="goalboxDetailItems">
                    <div className="minMax">
                      <p>{item.heading} target</p>
                      <p>
                        {item.target} {(item.heading === "Trading days" || item.heading === "Profitable Trading Days") && " Days"}
                      </p>
                    </div>
                    <div className="resultRecord">
                      <h2>
                        {item.heading} {"Remaining"}
                      </h2>
                      <p>
                        {item.remaining}
                        {(item.heading === "Trading days" || item.heading === "Profitable Trading Days") && " Days"}
                      </p>
                    </div>
                    {item.threshold && (
                      <div className="resultRecord">
                        <h2>
                          {item.heading} {"Threshold"}
                        </h2>
                        <p>{item.threshold}</p>
                      </div>
                    )}
                  </div>
                </div>
                {item.heading === "Daily loss" && (
                  <p style={{ color: data?.max_daily_loss_status === "failed" ? "red" : "inherit", fontFamily: "DM Sans" }}>
                    {data?.max_daily_loss_status === "failed" ? "Daily Loss Limit Exceeded" : `Timer Reset In: ${showRemaining()}`}
                  </p>
                )}
                <div className="progressBarWrapper">
                  <div className="goalBox_progress">
                    <span
                      className={`progress_bar ${item.heading === "Max loss"
                        ? "maxLoss"
                        : item.heading === "Profit"
                          ? "profit"
                          : item.heading === "Daily loss"
                            ? programObjective?.max_daily_loss_status === "failed" ? "maxLoss" : "dailyLoss"
                            : item.heading === "Trading days"
                              ? "tradingDays"
                              : "tradingDays"
                        }`}
                      style={{
                        width: `${item.percentage}%`,
                        backgroundColor: item.heading === "Daily loss" && programObjective?.max_daily_loss_status === "failed" ? '#ff4d4f' : undefined
                      }}
                    ></span>
                  </div>
                  <div className="progressValuesBox">
                    <p className="baseValue">{item?.heading === "Trading days" ? "0" : "$0.00"}</p>
                    <span className="progress_bar" style={{ width: `${item.percentage}%` }}>
                      <p className="progressValue">
                        {item.heading === "Daily loss" && programObjective?.max_daily_loss !== undefined ? (
                          <span style={{ color: programObjective?.max_daily_loss_status === "failed" ? '#ff4d4f' : 'inherit' }}>
                            {formatUSD(programObjective.max_daily_loss)}
                          </span>
                        ) : (item.heading === "Max loss" || item.heading === "Trading days" || item.heading === "Profitable Trading Days" || item.heading === "Profit") &&
                          item.minMax !== item.target &&
                          item.minMax !== undefined ? (
                          <span>{item.minMax}</span>
                        ) : null}
                      </p>
                    </span>
                    <p className="maxValue">{item.target}</p>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      {(data?.status === "passed" || data?.status === "failed") && (
        <div className="addon_List">
          {data?.status === "passed" ? (
            <div className="statistic_details_Wrapper program_objective">
              <div className="statistic_info">
                <h5>Passed At </h5>
                <p>{moment(programObjective?.passed_at).format("DD-MM-YYYY") || "N/A"}</p>
              </div>
              <div className="statistic_info">
                <h5>Passed Balance </h5>
                <p>{programObjective?.passed_balance ? formatUSD(programObjective?.passed_balance) : "N/A"}</p>
              </div>
              <div className="statistic_info">
                <h5>Passed Equity </h5>
                <p>{programObjective?.passed_equity ? formatUSD(programObjective?.passed_equity) : "N/A"}</p>
              </div>
            </div>
          ) : (
            data?.status === "failed" && (
              <div className="statistic_details_Wrapper program_objective">
                <div className="statistic_info">
                  <h5>Breached At </h5>
                  <p>{moment(programObjective?.breached_at).format("DD-MM-YYYY") || "N/A"}</p>
                </div>
                <div className="statistic_info">
                  <h5>Breached Balance </h5>
                  <p>{programObjective?.breached_balance ? formatUSD(programObjective?.breached_balance) : "N/A"}</p>
                </div>
                <div className="statistic_info">
                  <h5>Breached Equity </h5>
                  <p>{programObjective?.breached_equity ? formatUSD(programObjective?.breached_equity) : "N/A"}</p>
                </div>
                {programObjective?.breached_reason && (
                  <div className="statistic_info">
                    <h5>Breached Reason</h5>
                    <p>{breachedReasonMap[programObjective?.breached_reason] || "N/A"}</p>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default Goals;
